import { Fragment, useEffect, useState } from "react";
import AccountForm from "../../../forms/AccountForm";
import {
    Box, Button, Container, Paper,
    Step, StepLabel, Stepper, Typography
} from "@mui/material";
import MyProfil from "./account/MyProfil";
import PasswordForm from "../../../forms/PasswordForm";
import UserInformation from "../../../../types/UserInformation";
import { profilToAccessToAllFonctionnality } from "../../../../constants/Constants";
import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { Reducers } from "../../../../redux/reducers";
import { DataRef } from "../../../../types/DataRef";
import axios, { AxiosInstance } from "axios";
import Cookies from "universal-cookie";

const useStyles = makeStyles(() => ({
    root: {
        "& .Mui-active": {
            "&.MuiStepIcon-root": {
                color: "#FC8404",
                fontSize: "2rem",
            }
        },
    }
}));

const steps = ['Mon profil', 'Paramétrer mon profil', 'Modifier le mot de passe'];

const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;

const Account = () => {
    const logger = useSelector<Reducers>((state) => state.logger) as UserInformation;

    const cookies = new Cookies();
    const token: string = cookies.get("jwt");

    const http: AxiosInstance = axios.create({
        baseURL: urlBaseApi,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    const [dataPays, setDataPays] = useState<DataRef[]>([]);

    useEffect(() => {
        http.get('getallpays')
            .then(res => {
                Array.isArray(res.data) && setDataPays(res.data);
            }).catch(error => {
                console.log(error);
            });
    }, []);

    let initialStep = 0;

    if (!profilToAccessToAllFonctionnality.includes(logger?.profils?.libelle) && !logger?.updated_password) {
        initialStep = 2;
    }

    const [activeStep, setActiveStep] = useState<number>(initialStep);

    const classes = useStyles();

    const isAble = (profilToAccessToAllFonctionnality.includes(logger?.profils?.libelle) || logger?.updated_password) && true

    const handleNext = (): void => {
        if (isAble) {
            setActiveStep(activeStep + 1);
        }
    };

    const handleBack = (): void => {
        if (isAble) {
            setActiveStep(activeStep - 1);
        }
    };

    const handleChangeStep = (index: number) => {
        isAble && setActiveStep(index);
    }

    function getStepContent(step: number) {
        switch (step) {
            case 0:
                return <MyProfil user={logger} />;
            case 1:
                return <AccountForm user={logger} dataPays={dataPays} />;
            case 2:
                return <PasswordForm user={logger} />;
            default:
                throw new Error('Unknown step');
        }
    }

    return (
        <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
            <Paper variant="outlined" sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
                <Typography component="h1" variant="h4" align="center">
                    Mon compte
                </Typography>
                <Stepper
                    activeStep={activeStep}
                    sx={{ pt: 3, pb: 5 }}
                    alternativeLabel
                    className={classes?.root}
                >
                    {steps.map((label, index) => (
                        <Step
                            key={label}
                            onClick={() => handleChangeStep(index)}
                            completed={false}
                            sx={{ cursor: "pointer" }}
                        >
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <Fragment>
                    {getStepContent(activeStep)}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            variant="text"
                            disabled={!isAble || (activeStep === 0) && true}
                            onClick={handleBack}
                            sx={{ textTransform: "none", mt: 3, ml: 1 }}
                            color="warning"
                        >
                            Précedent
                        </Button>
                        <Button
                            variant="text"
                            disabled={(activeStep === steps.length - 1) && true}
                            onClick={handleNext}
                            sx={{ textTransform: "none", mt: 3, ml: 1 }}
                            color="warning"
                        >
                            Suivant
                        </Button>
                    </Box>
                </Fragment>
            </Paper>
        </Container>
    );
};

export default Account;